export default __webpack_public_path__ + "static/media/address-card.a2602c32.svg";